import { useState } from "react";
import Link from "next/link";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import SubscribeModal from "src/components/listing-search/project-radar-banner/ subscribeModal";
import ProjectRadarSVG from "@/src/assets/svg/components/projectRadar/ProjectRadarSVG";

import IconClose from "assets/svg/close.svg";

import styles from "./styles.module.css";

const ProjectRadarFixedBanner = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSubsrcibeModalOpen, setIsSubsrcibeModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const toggleExpand = () => {
    if (!isExpanded) {
      Ga4WithEventParameters({
        eventName: "proje-radari-kulakcik",
        eventParameters: { label: "kulakcik-ac" },
      });
    }
    setIsExpanded(!isExpanded);
    if (isVisible) {
      setIsVisible(false);
    } else {
      setTimeout(() => {
        setIsVisible(true);
      }, 150);
    }
  };

  const toggleSubscribeModal = () => {
    if (!isSubsrcibeModalOpen) {
      Ga4WithEventParameters({
        eventName: "proje-radari-kulakcik",
        eventParameters: { label: "abone-ol" },
      });
      window.location.hash = "proje-radari-abone";
      toggleExpand();
    } else {
      window.history.pushState("", document.title, window.location.pathname + window.location.search);
    }
    setIsSubsrcibeModalOpen((prev) => !prev);
  };

  const handleLinkClick = () => {
    Ga4WithEventParameters({
      eventName: "proje-radari-kulakcik",
      eventParameters: { label: "incele" },
    });
  };

  return (
    <>
      <div className={styles.container}>
        {!isExpanded ? (
          <div className={styles.smallBox} onClick={toggleExpand}>
            <div className={styles.verticalLogo}>
              <ProjectRadarSVG width={121} height={28} />
            </div>
          </div>
        ) : (
          <div className={styles.largeBox}>
            <button type="button" className={styles.closeButton} onClick={toggleExpand}>
              <IconClose />
            </button>
            <div className={styles.horizontalLogo}>
              <ProjectRadarSVG />
            </div>
            <p className={`${styles.largeBoxText} ${isVisible ? styles.visible : ""}`}>
              {isVisible && (
                <>
                  <span>Ödeme avantajlı fırsat projeleri</span> inceleyebilir veya Proje Radarı’na abone olarak{" "}
                  <span>sıfır konut projeler bültenini</span> mail kutunuzda görebilirsiniz!
                </>
              )}{" "}
            </p>
            <div className={`${styles.buttonsContainer} ${isVisible ? styles.visible : ""}`}>
              <a
                href="/proje-radari"
                rel="noopener noreferrer nofollow"
                onClick={handleLinkClick}
                className={styles.subscribeButton}
              >
                Hemen İncele
              </a>

              <button type="button" className={styles.projectRadarLink} onClick={toggleSubscribeModal}>
                Abone Ol
              </button>
            </div>
          </div>
        )}
      </div>
      <SubscribeModal isOpen={isSubsrcibeModalOpen} close={toggleSubscribeModal} />
    </>
  );
};

export default ProjectRadarFixedBanner;
